import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/img/yunpan-icon@3x.png'


const _withScopeId = n => (_pushScopeId("data-v-74ed48b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "file-item__pic-box" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "file-item__play-icon" }, null, -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "icomoon-white-play" }, null, -1))
const _hoisted_5 = {
  key: 1,
  class: "file-item__video-duration"
}
const _hoisted_6 = {
  key: 0,
  class: "file-item-tackback",
  src: _imports_0
}
const _hoisted_7 = { class: "file-item__main" }
const _hoisted_8 = { class: "file-item__name" }
const _hoisted_9 = { class: "file-item__speed" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: "file-item",
    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSelect && _ctx.handleSelect(...args)))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        class: _normalizeClass(["file-item__pic", {'is-file-icon': _ctx.iconLink.includes('backstage-img-ssl.a.88cdn.com')}]),
        src: _ctx.iconLink,
        alt: "图片"
      }, null, 10, _hoisted_2),
      (_ctx.isVideo && !_ctx.iconLink.includes('backstage-img-ssl.a.88cdn.com'))
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _hoisted_3,
            _hoisted_4
          ], 64))
        : _createCommentVNode("", true),
      (_ctx.videoDuration)
        ? (_openBlock(), _createElementBlock("span", _hoisted_5, _toDisplayString(_ctx.videoDuration), 1))
        : _createCommentVNode("", true)
    ]),
    (_ctx.file.type === 'user#download')
      ? (_openBlock(), _createElementBlock("img", _hoisted_6))
      : _createCommentVNode("", true),
    _createElementVNode("article", _hoisted_7, [
      _createElementVNode("p", _hoisted_8, _toDisplayString(_ctx.file.name), 1),
      _createElementVNode("section", null, [
        _createElementVNode("p", _hoisted_9, [
          _createElementVNode("span", null, _toDisplayString(_ctx.size), 1),
          _createElementVNode("span", {
            class: _normalizeClass(_ctx.downloading)
          }, _toDisplayString(_ctx.status), 3)
        ])
      ])
    ])
  ]))
}